import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

function getAuthHeader() {
  const token = localStorage.getItem('customer_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const authHeaders = getAuthHeader;

export const AuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);    // null = checking, false = not auth'd
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // Skip if processing OAuth callback
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem('customer_token');
    if (!token) {
      setCustomer(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setCustomer(data);
    } catch {
      localStorage.removeItem('customer_token');
      setCustomer(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem('customer_token', data.token);
    setCustomer(data);
    return data;
  };

  const register = async (name, email, password, source = null, tags = null) => {
    const payload = { name, email, password };
    if (source) payload.source = source;
    if (tags && tags.length) payload.tags = tags;
    const { data } = await axios.post(`${API}/auth/register`, payload);
    localStorage.setItem('customer_token', data.token);
    setCustomer(data);
    return data;
  };

  const googleLogin = async (sessionId, source = null, tags = null) => {
    const payload = { session_id: sessionId };
    if (source) payload.source = source;
    if (tags && tags.length) payload.tags = tags;
    const { data } = await axios.post(`${API}/auth/google`, payload);
    localStorage.setItem('customer_token', data.token);
    setCustomer(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch { /* ignore */ }
    localStorage.removeItem('customer_token');
    setCustomer(false);
  };

  return (
    <AuthContext.Provider value={{ customer, loading, login, register, googleLogin, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
